import { combineReducers } from "redux";

import reservationSlice from "../slice/reservation-slice/reservation-slice";

const reservationReducers = combineReducers({
  reservation: reservationSlice,
});

export default reservationReducers;
